import React from 'react'
import styled from 'styled-components'

const StyledLabel = styled.label`
    display: inline-block;
    margin-bottom: 0.5rem;
    font-weight: 500;
    color: #212529;
`

const Label = ({ children, ...props }) => {
    return <StyledLabel {...props}>{children}</StyledLabel>
}

export default Label
